<div class="win-notification">
  <div class="win-notification__header">
    <div class="win-notification__badge">
      @if (gameConfig()?.icon; as icon) {
        <svg-icon class="win-notification__badge-icon" [src]="icon" />
      }
      <span>{{ gameConfig()?.name }}</span>
    </div>

    <div class="win-notification__info">
      <span class="win-notification__text">You won</span>
      <span class="win-notification__amount">
        <app-balance-icon balance="skins" size="20px" />
        {{ totalValue() | number:'1.2-2' }}
      </span>
    </div>

    <button
      type="button"
      class="win-notification__close"
      aria-label="Dismiss"
      (click)="onClose()"
    >
      <svg-icon src="assets/icons/ui/cross.svg" />
    </button>
  </div>

  <div class="win-notification__content">
    <app-skins-row
      class="win-notification__skins"
      [skins]="skins()"
      [maxItemLength]="6"
      [showMoreTooltip]="false"
    />

    <a
      [href]="offerUrl()"
      target="_blank"
      rel="noopener"
      class="button button--style-yellow h-32 padding-x-12"
    >Accept Winnings</a>
  </div>
</div>
